import { render, staticRenderFns } from "./vertical-tab.vue?vue&type=template&id=1c015e70&lang=pug&"
import script from "./vertical-tab.vue?vue&type=script&lang=ts&"
export * from "./vertical-tab.vue?vue&type=script&lang=ts&"
import style0 from "./vertical-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports